export default {
  API_URL: process.env.REACT_APP_API_URL,
  S3_URL: process.env.REACT_APP_S3_URL,
  PORT: process.env.PORT,
  QUESTION_NAME: process.env.REACT_APP_QUESTION_NAME,
  BOT_API_URL: process.env.REACT_APP_API_ENDPOINT,
  APP_URL: process.env.REACT_APP_URL,
  LIFFSERVEY: process.env.REACT_APP_LIFF_SERVEY,
};
